import { SiteLayout } from "../components/SiteLayout";
import { landingByLocale, seoByLocale } from "../content";
import type { Locale } from "../content/types";
import { usePageSeo } from "../lib/seo";
import { FeatureSection } from "../sections/FeatureSection";
import { HeroSection } from "../sections/HeroSection";
import { ShowcaseSection } from "../sections/ShowcaseSection";

type LandingPageProps = {
  locale: Locale;
};

export function LandingPage({ locale }: LandingPageProps) {
  const content = landingByLocale[locale];
  usePageSeo({ locale, routeKind: "landing", seo: seoByLocale[locale].landing });

  return (
    <SiteLayout locale={locale} page="landing">
      <HeroSection content={content} locale={locale} />
      <FeatureSection features={content.features} />
      <ShowcaseSection showcase={content.showcase} />
    </SiteLayout>
  );
}
